var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
var __awaiter =
  (this && this.__awaiter) ||
  function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value)
          })
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value))
        } catch (e) {
          reject(e)
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value))
        } catch (e) {
          reject(e)
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected)
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next())
    })
  }
var __generator =
  (this && this.__generator) ||
  function (thisArg, body) {
    var _ = {
        label: 0,
        sent: function () {
          if (t[0] & 1) throw t[1]
          return t[1]
        },
        trys: [],
        ops: [],
      },
      f,
      y,
      t,
      g
    return (
      (g = { next: verb(0), throw: verb(1), return: verb(2) }),
      typeof Symbol === 'function' &&
        (g[Symbol.iterator] = function () {
          return this
        }),
      g
    )
    function verb(n) {
      return function (v) {
        return step([n, v])
      }
    }
    function step(op) {
      if (f) throw new TypeError('Generator is already executing.')
      while (_)
        try {
          if (
            ((f = 1),
            y &&
              (t = op[0] & 2 ? y['return'] : op[0] ? y['throw'] || ((t = y['return']) && t.call(y), 0) : y.next) &&
              !(t = t.call(y, op[1])).done)
          )
            return t
          if (((y = 0), t)) op = [op[0] & 2, t.value]
          switch (op[0]) {
            case 0:
            case 1:
              t = op
              break
            case 4:
              _.label++
              return { value: op[1], done: false }
            case 5:
              _.label++
              y = op[1]
              op = [0]
              continue
            case 7:
              op = _.ops.pop()
              _.trys.pop()
              continue
            default:
              if (!((t = _.trys), (t = t.length > 0 && t[t.length - 1])) && (op[0] === 6 || op[0] === 2)) {
                _ = 0
                continue
              }
              if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                _.label = op[1]
                break
              }
              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1]
                t = op
                break
              }
              if (t && _.label < t[2]) {
                _.label = t[2]
                _.ops.push(op)
                break
              }
              if (t[2]) _.ops.pop()
              _.trys.pop()
              continue
          }
          op = body.call(thisArg, _)
        } catch (e) {
          op = [6, e]
          y = 0
        } finally {
          f = t = 0
        }
      if (op[0] & 5) throw op[1]
      return { value: op[0] ? op[1] : void 0, done: true }
    }
  }
import { useFormikContext } from 'formik'
import React from 'react'
import styled from 'styled-components'
import { useODEntityContext } from '../..'
import { ODButton, ODButtonSize, ODButtonTheme, useODModalConfirm } from '../../..'
var FormButtonsWrapper = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ['\n  display: flex;\n  place-content: flex-end flex-end;\n'],
      ['\n  display: flex;\n  place-content: flex-end flex-end;\n']
    ))
)
var defaultDeleteConfirmOptions = {
  message: React.createElement(
    React.Fragment,
    null,
    '\uC815\uB9D0 \uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?',
    React.createElement('br', null),
    '\uB418\uB3CC\uB9B4 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.'
  ),
  yes: 'Confirm',
  no: 'Cancel',
}
export function ODEntityEditorFooter(props) {
  var _this = this
  var _a = props.saveButtonName,
    saveButtonName = _a === void 0 ? 'Save' : _a,
    deleteButtonName = props.deleteButtonName,
    deleteConfirmOptions = props.deleteConfirmOptions,
    onDeleted = props.onDeleted,
    _b = props.deleteButtonStyle,
    deleteButtonStyle = _b === void 0 ? {} : _b,
    _c = props.buttonStyle,
    buttonStyle = _c === void 0 ? {} : _c,
    _d = props.saveButtonStyle,
    saveButtonStyle = _d === void 0 ? {} : _d,
    _e = props.hideSaveButton,
    hideSaveButton = _e === void 0 ? false : _e
  var isSubmitting = useFormikContext().isSubmitting
  var onDelete = useODEntityContext().onDelete
  var _f = useODModalConfirm(deleteConfirmOptions || defaultDeleteConfirmOptions),
    Component = _f.Component,
    confirm = _f.confirm,
    confirmComponentProps = _f.props
  var handleDelete = React.useCallback(
    function () {
      return __awaiter(_this, void 0, void 0, function () {
        var _a
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4 /*yield*/, confirm()]
            case 1:
              if (!_b.sent()) return [3 /*break*/, 3]
              return [4 /*yield*/, onDelete()]
            case 2:
              _b.sent()
              ;(_a = onDeleted) === null || _a === void 0 ? void 0 : _a()
              _b.label = 3
            case 3:
              return [2 /*return*/]
          }
        })
      })
    },
    [confirm, onDelete, onDeleted]
  )
  return React.createElement(
    FormButtonsWrapper,
    null,
    React.createElement(Component, __assign({}, confirmComponentProps)),
    deleteButtonName &&
      React.createElement(
        ODButton,
        {
          theme: ODButtonTheme.PrimaryInvert,
          size: ODButtonSize.Small,
          rounded: true,
          style: __assign(__assign({ minWidth: 135, marginRight: 13 }, buttonStyle), deleteButtonStyle),
          onClick: handleDelete,
        },
        deleteButtonName
      ),
    !hideSaveButton &&
      React.createElement(
        ODButton,
        {
          type: 'submit',
          theme: ODButtonTheme.Primary,
          size: ODButtonSize.Small,
          rounded: true,
          style: __assign(__assign({ minWidth: 135 }, buttonStyle), saveButtonStyle),
          disabled: isSubmitting,
        },
        saveButtonName
      )
  )
}
var templateObject_1
//# sourceMappingURL=ODEntityEditorFooter.js.map
